'use client';

import { useEffect, useRef } from 'react';

export const useAutoPlayVideoOnIntersection = () => {
  const videoRef = useRef<HTMLVideoElement>(null);

  const intersectionObserver = useRef<IntersectionObserver | null>(null);

  // handle problems of autoplaying videos on mobile
  useEffect(() => {
    const listener = () => {
      if (!videoRef.current) {
        return;
      }
      videoRef.current.muted = true;
      videoRef.current.playsInline = true;
      if (!videoRef.current.played || videoRef.current.paused) {
        videoRef.current?.play();
      }
    };
    intersectionObserver.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            listener();
          }
        });
      },
      { threshold: 0.5 },
    );

    intersectionObserver.current.observe(videoRef.current as Element);

    return () => {
      if (intersectionObserver.current) {
        intersectionObserver.current.disconnect();
      }
    };
  }, []);

  return videoRef;
};
